import { FC, ReactElement } from 'react';
import classNames from 'classnames';
import XCircle from '@components/Icons/XCircle';
import RenderLoomVideo from '@components/Message/RenderLoomVideo';
import { SELF_ORIGIN } from '@configuration/client';
import s from './BannerHero.module.scss';
import Button from '../Button';

type ActionType = {
  label: string;
  onClick: () => void;
  loading?: boolean;
};

const BannerHero: FC<{
  title: string | ReactElement;
  description: string;
  loomUrl?: string;
  onDismiss?: () => void;
  color?: string;
  compact?: boolean;
  noodleBg?: boolean;
  actions: {
    primary: ActionType;
    secondary?: ActionType;
  };
}> = ({ title, description, loomUrl, onDismiss, actions, color, compact, noodleBg }) => (
  <section
    className={classNames(s.banner, compact && s.bannerCompact, noodleBg && s.noodleBg)}
    style={{
      backgroundImage: noodleBg ? `url(${SELF_ORIGIN}/images/noodle-bg.png), linear-gradient(112deg, #006DFF -13.76%, #FFF 165.43%)` : '',
      ...(color && {
        '--color-primary': color,
      }),
    }}
  >
    <span className={s.color} />
    <div>
      <div className={s.text}>
        <h1 className="heading-sm">{title}</h1>
        <p className="caption">{description}</p>
      </div>
      <div className={s.actions}>
        <Button onClick={actions.primary.onClick} size="sm" variant="primary" loading={actions.primary.loading}>
          {actions.primary.label}
        </Button>
        {actions.secondary && (
          <Button onClick={actions.secondary.onClick} size="sm" variant="secondary" loading={actions.secondary.loading}>
            {actions.secondary.label}
          </Button>
        )}
      </div>
    </div>
    {loomUrl && <RenderLoomVideo isFullWidth url={loomUrl} />}
    {onDismiss && (
      <button className={s.close} onClick={onDismiss}>
        <XCircle weight="fill" size={24} />
      </button>
    )}
  </section>
);

export default BannerHero;
